export default {
  props: ['selectIndex', 'selected', 'size'],
  computed: {
    addOnePackageUrl() {
      return this.size ? this.addOneBigPackages.selected[this.selectIndex] : this.addOnePackages.selected[this.selectIndex]
    },
    configData() {
      return this.size ? this.addOneBigPackages : this.addOnePackages
    },
  },
  methods: {
    selectAddOne() {
      this.$emit('slectedAddOneYuan')
    },
  },
}
